import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import Select from "react-select";
import { LoadingPortContext, resolvePageAccess } from "../../context/LoadingPortContext";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { EditorAttachFile } from "material-ui/svg-icons";
import { Delete, Edit, Trash } from "lucide-react"
import redirectURL from "../redirectURL.js";
import SweetAlert from 'react-bootstrap-sweetalert';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { getCellValue, getCellValueByPrefix, findByFieldIgnoreCase, isSameIgnoreCase, getUserIdentityFields } from "../common/utils";
const HubConsigneeCityMapping = () => {

    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);
    var allowActionsRef = useRef(false);
    var allowDeleteRef = useRef(false);
    // ---------------- DROPDOWN ----------------
    const loadingPorts = [
        { value: "CHN", label: "Chennai" },
        { value: "MUM", label: "Mumbai" },
        { value: "KOL", label: "Kolkata" }
    ];




    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        consignee_city: "",
        state: ""
    });

    const [hubData, setHubData] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [originalEditData, setOriginalEditData] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [consigneeCityData, setConsigneeCityData] = useState([]);
    const [stateData, setStateData] = useState([])

    const [hubConsigneeData, setHubConsigneeData] = useState([])
    const [vehicleCapacityData, setVehicleCapacityData] = useState([])
    // const handleChange = e =>
    //     setFormData({ ...formData, [e.target.name]: e.target.value });


    const handleChange = (e) => {
        const { name, value } = e.target;

        let errorMsg = "";

        // Positive number validation for freight_rate
        if (name === "freight_rate") {
            if (value === "") {
                errorMsg = "";
            } else if (!/^\d*\.?\d*$/.test(value)) {
                errorMsg = "Only positive numbers allowed";
            } else {
                const num = parseFloat(value);
                if (num <= 0) {
                    errorMsg = "Value must be greater than 0";
                }
            }
        }

        // Update form data
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Update error messages
        setInputErrors((prev) => ({ ...prev, [name]: errorMsg }));
    };
    const [inputErrors, setInputErrors] = useState({
        latitude: "",
        longitude: ""
    });

    const handlePortChange = (selected) => {
        // console.log(selected)
        setFormData({ ...formData, loading_port_code: selected.value, comp_short_name: selected.label });
    }

    // ---------------- VALIDATION ----------------
    const showValidationAlert = (message) => {
        setShow(true);
        setBasicType("warning");
        setBasicTitle(message);
    };

    const validateForm = () => {

        if (!formData.loading_port_code) {
            showValidationAlert("Select Loading Plant");
            return false;
        }

        if (!formData.hub_name) {
            showValidationAlert("Select Hub");
            return false;
        }

        if (!formData.consignee_city) {
            showValidationAlert("Select Consignee City");
            return false;
        }

        if (!formData.state) {
            showValidationAlert("Select State");
            return false;
        }

        if (!formData.vehicle_capacity) {
            showValidationAlert("Select Vehicle Type");
            return false;
        }

        if (!isValidNumber(formData.freight_rate)) {
            showValidationAlert("Freight Rate must be numeric");
            return false;
        }

        if (parseFloat(formData.freight_rate) <= 0) {
            showValidationAlert("Freight Rate must be greater than 0");
            return false;
        }

        if (!formData.freight_type) {
            showValidationAlert("Select Freight Type");
            return false;
        }

        return true;
    };

    // ---------------- ADD / UPDATE ----------------
    const handleAdd = async () => {

        if (!validateForm()) return;

        if (inputErrors.freight_rate) {
            showValidationAlert(inputErrors.freight_rate);
            return
        }

        if (editIndex !== null && originalEditData) {
            const noChange = String(formData.freight_rate) === String(originalEditData.freight_rate) &&
                String(formData.freight_type) === String(originalEditData.freight_type);
            if (noChange) {
                setShow(true)
                setBasicType("warning")
                setBasicTitle("No changes found. Please modify at least one field before updating.")
                return;
            }
        }

        setLoadshow("show-m")
        setOverly("show-m")
        const payload = {
            loading_port_code: formData.loading_port_code,
            comp_short_name: formData.comp_short_name,
            hub_name: formData.hub_name,
            consignee_city: formData.consignee_city,
            state: formData.state,
            vehicle_capacity: formData.vehicle_capacity,
            freight_rate: parseFloat(formData.freight_rate),
            freight_type: formData.freight_type,
            is_active: 1,
            ...getUserIdentityFields()
        };
        await updateHubConsigneeData([payload], editIndex !== null)
        await getHubConsigneeData(loadingPortCode);

        closeSlider();
        setLoadshow("show-n")
        setOverly("show-n")
    };

    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setOriginalEditData(null);
        setFormData({
            loading_port_code: null,
            hub_name: null,
            consignee_city: null,
            state: null,
            vehicle_capacity: null,
            freight_rate: "",
            freight_type: ""
        });
        setShowBulkSlider(false)
        setValidData([])
        setErrors([])
        setFileName("")
    };

    // ---------------- EDIT ----------------
    const handleEdit = (params) => {
        setFormData(params.data);
        setOriginalEditData(params.data);
        setEditIndex(params.rowIndex);
        setShowSlider(true);
    };

    // ---------------- DELETE ----------------
    const handleDelete = async (params) => {
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        const payload = {
            loading_port_code: params.data.loading_port_code,
            hub_name: params.data.hub_name,
            consignee_city: params.data.consignee_city,
            state: params.data.state,
            vehicle_capacity: params.data.vehicle_capacity,
            is_active: 1,  // usually delete = deactivate
            ...getUserIdentityFields()
        };

        console.log(payload);
        setLoadshow("show-m")
        setOverly("show-m")
        await deleteHubConsigneeData([payload])
        await getHubConsigneeData(params.data.loading_port_code);
        setLoadshow("show-n")
        setOverly("show-n")
    };



    const ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            {allowActionsRef.current && <Edit className="text-primary cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { handleEdit(props) }} />}
            {allowDeleteRef.current && <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { handleDelete(props) }} />}
        </div>
    );
    // ---------------- GRID ----------------
    const components = {
        actionRenderer: ActionRenderer
    };
    const columnDefs = [
        {
            headerName: "",
            width: 100,
            cellRenderer: "actionRenderer",
            pinned: "left",
            headerCheckboxSelection: allowDeleteRef.current ? true : false,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: allowDeleteRef.current ? true : false,
            hide: (!allowActionsRef.current && !allowDeleteRef.current)
        },
        // { headerName: "Source", field: "comp_short_name", flex: 1 },
        { headerName: "Hub", field: "hub_name", flex: 1 },
        { headerName: "Consignee City", field: "consignee_city", flex: 1 },
        { headerName: "State", field: "state", flex: 1 },
        { headerName: "Vehicle Type", field: "vehicle_capacity", flex: 1 },
        { headerName: "Freight Rate ( ₹ )", field: "freight_rate", flex: 1 },
        {
            headerName: "Freight Type", field: "freight_type", flex: 1,
            cellRenderer: (params) => {
                if (params.data.freight_type == "PER_CMT") {
                    return "PER CMT"
                } else if (params.data.freight_type == "PER_TRIP") {
                    return "PER TRIP"
                }
                return params.data.freight_type
            }
        }
    ];

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var port = await pageAccessFn();
            await getNecessaryData(port);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);
    const getNecessaryData = async (port) => {
        await getHubData({ is_active: 1, loading_port_code: port })
        await getConsigneeCityData({ loading_port_code: port, is_active: 1 })
        await getVehicleCapacityData({ loading_port_code: port, hub_vehicle: 1, status: 1 })
        await getHubConsigneeData(port);
    }


    const getHubConsigneeData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                is_active: 1
            }
            const response = await redirectURL.post("/masters/getHubCityFreights", params);
            if (response.data.status == "success") {
                setHubConsigneeData(response.data.hubCityFreights || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getHubData = async (params) => {
        try {
            const response = await redirectURL.post("/masters/getHubMasterData", params);
            if (response.data.status == "success") {
                setHubData(response.data.hubData
                    .map((each) => {
                        return { ...each, label: each.hub_name, value: each.hub_name }
                    })
                    || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getConsigneeCityData = async (params) => {
        try {
            const response = await redirectURL.post("/masters/getHubConsigneeCity", params);
            // console.log(response)
            if (response.data.status == "success") {
                setConsigneeCityData(response.data.hubMappingData
                    .map((each) => {
                        return { ...each, label: each.consignee_city, value: each.consignee_city }
                    })
                    || [])
                return response.data.hubMappingData
                    .map((each) => {
                        return { ...each, label: each.consignee_city, value: each.consignee_city }
                    })
                    || []
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getVehicleCapacityData = async (params) => {
        try {
            const response = await redirectURL.post("lmconsignees/getLmVehicleCapacity", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                // getLmVehicleCapacity is queried here without a zone/hub filter, so it
                // returns one lmvehiclecapacity row PER HUB for hub_vehicle:1 records
                // (each hub's copy of "10 Tonner" etc. is its own document, keyed by
                // zone=hub name) - same vehicle_cap value repeated once per hub, which
                // showed up as duplicate options in this dropdown. Dedupe by
                // vehicle_cap since this picker only needs the distinct type names,
                // not which hub each copy happens to belong to.
                var seenVehicleCaps = new Set();
                var uniqueVehicleCapRows = (response.data || []).filter((each) => {
                    if (seenVehicleCaps.has(each.vehicle_cap)) return false;
                    seenVehicleCaps.add(each.vehicle_cap);
                    return true;
                });
                setVehicleCapacityData(
                    uniqueVehicleCapRows.map((each) => ({
                        ...each,
                        label: each.vehicle_cap,
                        value: each.vehicle_cap
                    }))
                );
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const updateHubConsigneeData = async (params, isEdit) => {
        try {

            const response = await redirectURL.post("/masters/updateHubCityFreights", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
                setShow(true)
                setBasicType("success")
                setBasicTitle(isEdit ? "Updated Successfully." : "Added Successfully.")
            } else {
                setShow(true)
                setBasicType("danger")
                setBasicTitle(isEdit ? "Failed to update." : "Failed to Add.")
            }
        } catch (error) {
            console.log(error)
            setShow(true)
            setBasicType("danger")
            setBasicTitle(isEdit ? "Failed to update." : "Failed to Add.")
        }
    }
    const deleteHubConsigneeData = async (payload) => {
        try {
            var params = payload
            const response = await redirectURL.post("/masters/deleteHubCityFreights", params);
            if (response.data.status == "success") {
                setSelectedRows([])
                setShow(true)
                setBasicType("success")
                setBasicTitle("Deleted Successfully.")
                // setRowData(response.data.hubData || [])
            } else {
                setShow(true)
                setBasicType("danger")
                setBasicTitle("Failed to Delete.")
            }
        } catch (error) {
            console.log(error)
            setShow(true)
            setBasicType("danger")
            setBasicTitle("Failed to Delete.")
        }
    }

    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData.map((each) => {
                return (
                    {
                        ...each,
                        loading_port_code: loadingPortCode,
                        comp_short_name: loadingPortData.find((each) => each.value == loadingPortCode).label || "",
                        is_active: 1,
                        ...getUserIdentityFields()
                    }
                )
            })
            console.log(validData, finalData)

            await updateHubConsigneeData(finalData, false)
            await getHubConsigneeData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setFileName("")

            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };
    const downloadTemplate = async () => {
        const response = await redirectURL.post(
            "/masters/downloadHubTemplate",
            {}, // body if needed
            { responseType: "blob" } // important for Excel download
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Hub_Bulk_Upload_Template.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const handleDeleteSelected = async (port) => {
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        var payload = selectedRows.map((each) => {
            return {
                loading_port_code: each.loading_port_code,
                hub_name: each.hub_name,
                consignee_city: each.consignee_city,
                state: each.state,
                // Each row's own vehicle_capacity, not the slider form's
                // leftover value - the backend filter now matches on this
                // field too, so sending the wrong one would delete a sibling
                // vehicle-type record (or match nothing) instead of this row.
                vehicle_capacity: each.vehicle_capacity,
                is_active: 1,
                ...getUserIdentityFields()
            }
        })
        setLoadshow("show-m")
        setOverly("show-m")
        await deleteHubConsigneeData(payload)
        await getHubConsigneeData(port);
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const [selectedRows, setSelectedRows] = useState([]);
    // console.log(loadingPortData, editIndex)
    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        container: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        })
    }


    const updateStateData = (formData, consigneeCityData) => {
        // console.log("huawei", consigneeCityData, consigneeCityData
        //     .filter(each => each.city === formData.consignee_city))
        if (!formData.consignee_city) return;

        const states = [
            ...new Set(
                consigneeCityData
                    .filter(each => each.consignee_city === formData.consignee_city)
                    .map(each => each.state)
            )
        ];

        // console.log(states);
        if (states.length > 0 && states.length < 2) {
            setFormData((prevState) => ({ ...prevState, state: states[0] }))
        }
        setStateData(states.map((each) => ({ label: each, value: each })));
    }

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");

    const fileInputRef = useRef(null);
    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")
        setValidData([])
        setErrors([])
        setFileName("")
    }

    const pageAccessFn = useCallback(async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            return resolved.loading_port_code;
        } catch (err) {
            console.log(err);
        }

    }, [portContext]);

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await getNecessaryData(selectedPlant);
        setValidData([]);
        setErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!formData.loading_port_code) return;
            // setLoadshow("show-m")
            // setOverly("show-m")
            // // ✅ This runs whenever loading_port_code updates
            // // console.log("Updated:", formData.loading_port_code);
            // await getHubData({ is_active: 1, loading_port_code: formData.loading_port_code })
            // var data = await getConsigneeCityData({ loading_port_code: formData.loading_port_code, status: 1 })
            // await getVehicleCapacityData({ loading_port_code: formData.loading_port_code, status: 1 })
            // updateStateData(formData, consigneeCityData);
            // setLoadshow("show-n")
            // setOverly("show-n")
            // updateStateData(formData, consigneeCityData);
            updateStateData(formData, consigneeCityData);

        }

        fetchData();

    }, [formData.loading_port_code]);

    const freightTypeList = [
        { label: "PER CMT", value: "PER_CMT" },
        { label: "PER TRIP", value: "PER_TRIP" }
    ]

    const isValidNumber = (value) => {
        const str = String(value).trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };

    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };

    // ================= VALIDATION =================


    const validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        console.log(data)

        data.forEach((row, index) => {

            const rowNumber = index + 2; // Excel row (header = 1)

            let hubNameInput = String(getCellValue(row, "HUB") || "").trim();
            let consigneeCityInput = String(getCellValue(row, "CONSIGNEE CITY") || "").trim();
            let stateInput = String(getCellValue(row, "STATE") || "").trim();
            // Template column is "VEHICLE TYPE" (renamed from "VEHICLE CAPACITY" to
            // match the UI label) - still stored as vehicle_capacity below, no DB
            // field rename needed.
            let vehicleCapacityInput = String(getCellValue(row, "VEHICLE TYPE") || "").trim();
            let freightRate = getCellValueByPrefix(row, "FREIGHT RATE");
            let freightTypeInput = String(getCellValue(row, "FREIGHT TYPE") || "").trim();

            const matchedHub = findByFieldIgnoreCase(hubData, "hub_name", hubNameInput);
            let hubName = matchedHub ? matchedHub.hub_name : hubNameInput.toUpperCase();

            const hubCityRecords = (consigneeCityData || []).filter((each) => isSameIgnoreCase(each.hub_name, hubName));
            const matchedCity = hubCityRecords.find((each) => isSameIgnoreCase(each.consignee_city, consigneeCityInput));
            const matchedState = hubCityRecords.find((each) =>
                isSameIgnoreCase(each.consignee_city, consigneeCityInput) && isSameIgnoreCase(each.state, stateInput)
            );
            const matchedVehicle = findByFieldIgnoreCase(vehicleCapacityData, "value", vehicleCapacityInput);

            let consigneeCity = matchedCity ? matchedCity.consignee_city : consigneeCityInput;
            let state = matchedState ? matchedState.state : stateInput;
            let vehicleCapacity = matchedVehicle ? matchedVehicle.value : vehicleCapacityInput;
            let freightType = freightTypeInput.toUpperCase().replace(/\s+/g, "_");

            let rowErrors = [];

            // ---- Hub Name ----
            if (!matchedHub) {
                rowErrors.push(`Hub - "${hubNameInput}" does not exist in Hub Master.`);
            }
            if (!matchedCity) {
                rowErrors.push(`Consignee City - "${consigneeCityInput}" is not mapped to Hub "${hubNameInput}".`);
            }
            if (!matchedState) {
                rowErrors.push(`State - "${stateInput}" is not mapped to Consignee City and Hub.`);
            }
            if (!matchedVehicle) {
                rowErrors.push(`Vehicle Type - "${vehicleCapacityInput}" does not exist in vehicle Details".`);
            }
            // ---- Freight Rate ----
            if (
                // latitude === "" ||
                !isValidNumber(freightRate)
            ) {
                rowErrors.push(
                    `Freight Rate should be numeric (${freightRate})`
                );
            } else if (parseFloat(freightRate) <= 0) {
                rowErrors.push(
                    `Freight Rate must be greater than 0 (${freightRate})`
                );
            }

            // ---- Longitude ----
            if (
                !freightType
            ) {
                rowErrors.push(
                    `Invalid Freight Type (${freightTypeInput})`
                );
            }

            // ---- Collect Errors ----
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                cleanedData.push({
                    // loading_port_code: loadingPortCode,
                    // comp_short_code: loadingPortData.find((each) => each.loading_port_code == loadingPortCode),
                    hub_name: hubName,
                    consignee_city: consigneeCity,
                    state: state,
                    vehicle_capacity: vehicleCapacity,
                    freight_rate: parseFloat(freightRate),
                    freight_type: freightType
                });
            }
        });

        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }

        setErrors(errorList);
        setValidData(cleanedData);

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };




    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = validData.length == 0
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    const closeAlert = () => {
        setShow(false)

    }
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    console.log(formData, stateData, editIndex, errors)
    const onExportClick = () => {
        if (gridRef.current && gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            gridRef.current.api.exportDataAsExcel({
                fileName: "hub_city_freights.xlsx"
            });
        }
    };
    if (pageAccess != 2) {
        allowActionsRef.current = true;
    }
    if (pageAccess == 3) {
        allowDeleteRef.current = true;
    }
    return (
        <div className="hub-master-container d-flex flex-column" style={{ height: "100%", overflowY: "auto" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                styles={{ zIndex: "10000001" }}
            >
            </SweetAlert>
            {/* HEADER */}
            <div className="master-header">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Hub City Freights</h5>
                </div>

                <div className="d-flex align-items-center d-none" style={{ gap: "8px" }}>
                    {(selectedRows.length > 0 && allowDeleteRef.current) && <button
                        className="pill-btn pill-btn-danger"
                        onClick={() => { handleDeleteSelected(loadingPortCode) }}
                        disabled={selectedRows.length == 0}
                    >
                        Delete Selected
                    </button>}
                    <button
                        className="pill-btn pill-btn-primary"
                        onClick={() => { onExportClick() }}
                    >
                        Export Data
                    </button>
                    {allowActionsRef.current && <button
                        className="pill-btn pill-btn-success"
                        onClick={() => {
                            setShowSlider(true);
                            var object = loadingPortData.find((each) => each.value == loadingPortCode)
                            setFormData((prevState) => ({
                                ...prevState,
                                loading_port_code: object.value, comp_short_name: object.label
                            }))
                        }}
                    >
                        + Add
                    </button>}
                    {allowActionsRef.current && <button
                        className="pill-btn pill-btn-info"
                        onClick={() => {
                            setErrors([]);
                            setValidData([]);
                            setFileName("");
                            setShowBulkSlider(true);
                        }}
                    >
                        Import Data
                    </button>}
                </div>
            </div>

            <div className="container-fluid mb-3 d-none" style={{ padding: "9px 25px", backgroundColor: "#efefef", borderRadius: "10px" }}>
                <div className="row gap-3">
                    <div className="col-2" style={{ padding: "5px" }}>
                        <div className="p-1" style={{ color: "#000!important" }}>
                            <label className="m-0">Source</label>
                            <Select
                                options={loadingPortData}
                                value={loadingPortData.find((each) => each.value == formData.loading_port_code)}
                                onChange={handlePortChange}
                                classNamePrefix="react-select" className="mt-1"
                                isDisabled={editIndex != null}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className="col-2" style={{ padding: "5px" }}>
                        <div className="p-1">
                            <label className="m-0">Hub</label>
                            <Select
                                options={loadingPortData}
                                value={loadingPortData.find((each) => each.value == formData.loading_port_code)}
                                onChange={handlePortChange}
                                classNamePrefix="react-select" className="mt-1"
                                isDisabled={editIndex != null}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className="col-2" style={{ padding: "5px" }}>
                        <div className="p-1">
                            <label className="m-0">Consignee City</label>
                            <Select
                                options={loadingPortData}
                                value={loadingPortData.find((each) => each.value == formData.loading_port_code)}
                                onChange={handlePortChange}
                                classNamePrefix="react-select" className="mt-1"
                                isDisabled={editIndex != null}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className="col-2" style={{ padding: "5px" }}>
                        <div className="p-1">
                            <label className="m-0">State</label>
                            <Select
                                options={loadingPortData}
                                value={loadingPortData.find((each) => each.value == formData.loading_port_code)}
                                onChange={handlePortChange}
                                classNamePrefix="react-select" className="mt-1"
                                isDisabled={editIndex != null}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className="col-2" style={{ padding: "5px" }}>
                        <div className="p-1 d-flex align-items-end" style={{ height: "100%" }}>
                            <button className="add-hub-btn" style={{ padding: "5px 25px" }}>
                                + Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* GRID */}
            <div className="ag-theme-balham grid-wrapper mt-2" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={hubConsigneeData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}

                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "center" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    sideBar={{
                        toolPanels: [
                            {
                                id: 'columns',
                                labelDefault: 'Columns',
                                iconKey: 'columns',
                                toolPanel: 'agColumnsToolPanel'
                            },
                            {
                                id: 'filters',
                                labelDefault: 'Filters',
                                iconKey: 'filter',
                                toolPanel: 'agFiltersToolPanel'
                            }
                        ],
                        // defaultToolPanel: 'filters'
                    }}
                    animateRows rowSelection={"multiple"}
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }} suppressRowClickSelection={true}
                />
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}

            {/* RIGHT SLIDER */}
            <div className={`hub-slider ${showSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    {editIndex !== null ? "Edit Hub City Freight" : "Add New Hub City Freight"}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 pt-4">

                    <label className="m-0">Loading Plant <span className="text-danger">*</span></label>
                    <Select
                        options={loadingPortData}
                        value={loadingPortData.find((each) => each.value == formData.loading_port_code) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, loading_port_code: selected.value, comp_short_name: selected.label });
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={true}
                        styles={customStyles}
                    />

                    <label className="m-0">Hub <span className="text-danger">*</span></label>
                    <Select
                        options={hubData}
                        value={hubData.find((each) => each.value == formData.hub_name) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, hub_name: selected.value, consignee_city: "", state: "" });
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={!formData.loading_port_code || editIndex != null}
                        styles={customStyles}
                    />

                    <label className="m-0">Consignee City <span className="text-danger">*</span></label>
                    <Select
                        options={
                            formData.hub_name ? consigneeCityData.filter((each) => each.hub_name == formData.hub_name) : consigneeCityData
                        }
                        value={consigneeCityData.find((each) => each.value == formData.consignee_city) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, consignee_city: selected.value });
                            updateStateData({ ...formData, consignee_city: selected.value }, consigneeCityData);
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={!formData.loading_port_code || editIndex != null}
                        styles={customStyles}
                    />

                    <label className="m-0">State <span className="text-danger">*</span></label>
                    <Select
                        options={stateData}
                        value={stateData.find((each) => each.value == formData.state) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, state: selected.value });
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={!formData.loading_port_code || !formData.consignee_city || stateData.length < 2 || editIndex != null}
                        styles={customStyles}
                    />

                    <label className="m-0">Vehicle Type <span className="text-danger">*</span></label>
                    <Select
                        options={vehicleCapacityData}
                        value={vehicleCapacityData.find((each) => each.value == formData.vehicle_capacity) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, vehicle_capacity: selected.value });
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={!formData.loading_port_code || editIndex != null}
                        styles={customStyles}
                    />

                    <label className="m-0">Freight Rate ( ₹ )<span className="text-danger">*</span></label>
                    <input
                        type="number"
                        name="freight_rate"
                        value={String(formData.freight_rate || "")}
                        onChange={handleChange} className="mb-2"
                    // style={{ cursor: editIndex != null && "not-allowed" }}
                    />
                    <label className="m-0 text-danger">{inputErrors.freight_rate}</label>

                    <label className="m-0">Freight Type <span className="text-danger">*</span></label>
                    {/* <input
                        name="freight_type"
                        value={formData.freight_type}
                        onChange={handleChange} className="mb-2"
                    // style={{ cursor: editIndex != null && "not-allowed" }}
                    /> */}
                    <Select
                        options={freightTypeList}
                        value={freightTypeList.find((each) => each.value == formData.freight_type) || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, freight_type: selected.value });
                        }}
                        classNamePrefix="react-select" className="mb-2"
                        // isDisabled={true}
                        styles={customStyles} menuPlacement={"auto"}
                    />

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px" }}
                        onClick={handleAdd}
                    >
                        {editIndex !== null ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Import Data
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <a href={require("../../assets/hub_city_freights.csv")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                            Download Sample Template
                        </a>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}


                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                    <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Submit only valid data" : "Submit"}
                    </button>
                </div>

            </div>


            <div className={"dataLoadpageimg " + (loadshow)} style={{ zIndex: 100 }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>

        </div>
    );
};

export default HubConsigneeCityMapping;